import { render, staticRenderFns } from "./BaseWindow.vue?vue&type=template&id=640b09a9&scoped=true&"
import script from "./BaseWindow.vue?vue&type=script&lang=js&"
export * from "./BaseWindow.vue?vue&type=script&lang=js&"
import style0 from "./BaseWindow.vue?vue&type=style&index=0&id=640b09a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b09a9",
  null
  
)

export default component.exports